export default "__VITE_ASSET__DvVgbkdx__"